import { render, staticRenderFns } from "./BaseDashboardView.vue?vue&type=template&id=b8c13a78&"
import script from "./BaseDashboardView.vue?vue&type=script&lang=js&"
export * from "./BaseDashboardView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports